import SanityClient from '@sanity/client';

const Sanity = SanityClient({
  projectId: process.env.SANITY_PROJECT_ID as string,
  dataset: process.env.SANITY_DATASET || 'production',
  useCdn: true,
});

export default Sanity;
